/* Please update below variables as per store theme */

/*
 * Set the Add to Cart Button Id Selector Here
 */
var artifiButtonAddToCart = '#buttonAddToCart';

/*
 * Set the Span Selector having Add to Cart Button Text Here
 */
var artifiSpanAddToCartText = '#artifiPersonalizeText';

/*
 * Set the Id of Hidden Product Select Dropdown Here
 */
var artifiHiddenProductSelector = '[id^="MasterSelect-"]';

/*
 * Personalize Button class
 */
var artifiPersonalizeButtonClass = "btn";

/*
 * Javascript to add artifi functionality to the shopify store
 */
//Production
var artifi_app_api_key = "48b74a9f514bf0ebca6d629aa57e72e0";
var artifyUrl = 'https://sa.artifi.net/';

//Integration
// var artifi_app_api_key = "0484fe816a75f80d79f7b6564be1e3dc";
// var artifyUrl = 'https://shopifytest.artifi.net/';

var artifiCustomSessionId = '';
var artifiIsGuest = '';
var pdfApiPath = artifyUrl+"getPDF.php";
var xmlApiPath = artifyUrl+"getXml.php";

/*
 * Function to get request parameters
 */
function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/* 
 * Function to open personalization Iframe
 */
var hasExecuted = 0;
var getArtifiSku = 0;

function openPersonalizeIframe(extraQueryString) {    
    var variant_id = getParameterByName('id') || $('#ProductArtifiForm').attr('data-variant-id');
    var product_id = getParameterByName('product') || $('#ProductArtifiForm').attr('data-product-id');
    var quantity = getParameterByName('quantity');

    extraQueryString = 'productDetails={"productId":' + product_id + ',"quantity":' + quantity + '}';

    if (getArtifiSku === 0 && website_id !== 14) {
        jQuery.ajax({
            url: artifyUrl + 'getProductSkus.php?website_id=' + website_id + '&variant_id=' + variant_id,
            done: function(result) {
                if (result !== '') {
                    var variantObj = JSON.parse(result);
                    jQuery.each(variantObj, function(i, val) {
                        jQuery('body').append('<input type = "hidden" name = "artifi_sku_' + val.artifi_sku + '" value = "' + val.variant_id + '">');
                    });
                }
            }
        });
        getArtifiSku = 1;
    }


    if (typeof Artifi === 'undefined' || Artifi === null || hasExecuted == 1) {
        return;
    }

    artifiCustomSessionId = jQuery('#artifiUserId').val();
    artifiIsGuest = 'false';
    if (!artifiCustomSessionId) {
        artifiCustomSessionId = getArtifiCustomSessionId();
        // var artifiCustomSessionId = getParameterByName("userIdInQuote");
        artifiIsGuest = 'true';
    }

    var artifiUrl = artifyUrl + 'index.php';
    var artifiProductSku = getParameterByName('artifiProductSku') || $('#ProductArtifiForm').attr('data-product-sku');

    if (artifiProductSku !== "undefined" && artifiProductSku !== '' && artifiProductSku !== null) {
        product_id = artifiProductSku;
    }

    var designId = getParameterByName('design_id') || $('#ProductArtifiForm').attr('data-design-id');
    var issimple = getParameterByName('issimple') || $('#ProductArtifiForm').attr('data-issimple');
    var editMode = getParameterByName('mode');
    var guestinquote = getParameterByName('guestinquote');
    if (typeof extraQueryString === "undefined" && extraQueryString === '' && extraQueryString === null) {
        extraQueryString = '';
    }
    var childSku = '';
    if (issimple === '0') {
        childSku = product_id;

        var artifiVariantSku = getParameterByName('artifiSku') || $('#ProductArtifiForm').attr('data-artifi-sku');
        if (artifiVariantSku !== "undefined" && artifiVariantSku !== '' && artifiVariantSku !== null) {
            childSku = artifiVariantSku;
        }
    }

    hasExecuted = 1;


    if (editMode === 'reorder') {
        console.log('reoder initialize')
        Artifi.Initialize({
            productCode: childSku,
            websiteId: website_id,
            userId: jQuery('#artifiUserId').val(),
            divId: 'artifiIframeContainer',
            webApiclientKey: webapi_client_key,
            appMode: "reorder",
            isGuest: artifiIsGuest,
            width: '100%',
            height: '100%',
            designId: designId,
            sku: product_id,
            extraQueryString: extraQueryString,
            cartQueryString: ''
        });
    } else {
        //if (designId && (jQuery('#artifiUserId').val() === '' || guestinquote === '1')) { // Case :: Edit
            if (designId) { // Case :: Edit
        console.log('edit initialize')
            var userIdInQuote = getParameterByName("userIdInQuote");
            jQuery.getJSON('/cart.js').done(function(data) {
                //var responseObject = JSON.parse(data);
                Artifi.Initialize({
                    productCode: product_id,
                    websiteId: website_id,
                    userId: userIdInQuote,
                    divId: 'artifiIframeContainer',
                    webApiclientKey: webapi_client_key,
                    isGuest: artifiIsGuest,
                    width: '100%',
                    height: '100%',
                    designId: designId,
                    sku: childSku,
                    extraQueryString: extraQueryString,
                    cartQueryString: ''
                });
            });
        } else { 
            // Case :: Add
                    console.log('add initialize')
            Artifi.Initialize({
                productCode: product_id,
                websiteId: website_id,
                userId: artifiCustomSessionId,
                divId: 'artifiIframeContainer',
                webApiclientKey: webapi_client_key,
                isGuest: artifiIsGuest,
                width: '100%',
                height: '100%',
                designId: designId,
                sku: childSku,
                extraQueryString: extraQueryString,
                cartQueryString: ''
            });
        }
    }
}

/*
 * Function called on Add to cart
 */
function receiveMessage(event) {    
    if( integration_type != "headless" ) {
        var guestinquote = getParameterByName('guestinquote');


        if (typeof Artifi !== 'undefined' && typeof Artifi.isValidArtifiDomain === "function") {
            if (!Artifi.isValidArtifiDomain(event.origin)) {
                return false;
            }
        }


        if (event.data === "") {
            return;
        }

        if (typeof event.data !== "string") return; // ignore objects

        if (!event.data || !event.data.includes("artifi")) return;

        const eventdata = JSON.parse(event.data);
        
        if (eventdata.action === "add-to-cart") {
            console.log('add-to-cart')
            // console.log(eventdata)
            jQuery('.artifi-loader').show();
            //Add the product to cart now
            var quantity = getParameterByName('quantity');
            var lineItemId = getParameterByName('line_item_id');
            var variant_id = getParameterByName('id');
            var product_id = getParameterByName('product');
            var designId = getParameterByName('design_id');
            var artifiMode = getParameterByName('mode');
            var customSessionId = getParameterByName('customSessionId');
            var thumbImages = eventdata.data.savedDesigns;
            var thumbImagesArray = thumbImages.toString().split(',');
            var baseUrl = window.location.protocol + "//" + window.location.host;
            var guestinquote = '0';
            if (eventdata.data.userId === '') {
                guestinquote = '1';
            }

            $('#ProductArtifiForm').find('.item-image-container').each(function() {
                $(this).find('.variant-image').attr('src', eventdata.data.savedDesigns[0]);
            });

            if (eventdata.data.productCode == 'Bass Drumhead'){
                const designerID = eventdata.data.custmizeProductId;
                let portTemplate = false;
                let dataSku = eventdata.data.sku;

                const url = `${artifi_integration_url}/Designer/Services/GetCustomizedProductById?customizedProductId=${designerID}&websiteId=${website_id}&webApiClientKey=${webapi_client_key}`;

                fetch(url)
                  .then(response => response.json())
                  .then(data => {
                    // console.log(data)
                    if (data.Data.CustomDesignModelList[0].TemplateCode.includes('Port')){
                        portTemplate = true;
                    }

                    if (portTemplate){
                        dataSku = dataSku + 'P';
                    }

                    $('#ProductArtifiForm').find('.product-variant-item').each(function() {
                        if ($(this).attr('data-variant-sku') === dataSku) {
                            $(this).removeClass('hidden');
                            $(this).attr('aria-hidden', 'false')
                        }

                        if ($(this).attr('aria-hidden') === 'true') {
                            $(this).addClass('hidden');
                        }
                    }); 
                })
                  .catch(error => console.error("Error:", error));

            } else{
                const artifiAttributes = eventdata.data.attributes;

                const variants = document.querySelectorAll('.product-variant-item');

                const matchingElements = [];

                variants.forEach(element => {
                    const dataAttr = element.getAttribute('data-attributes');
                    if (!dataAttr) return;
                    
                    let elementData;
                    try {
                        elementData = JSON.parse(dataAttr);
                    } catch (e) {
                        console.error('Error parsing JSON from element:', e);
                    return;
                    }

                    // console.log(elementData)
                    
                    const normalize = val => typeof val === 'string' ? val.replace(/\s*\(.*$/, '').trim() : val;

                    const allMatch = artifiAttributes.every(filterObject => {
                      for (const key in filterObject) {
                        const filterValue = normalize(filterObject[key]);
                        const elementValue = normalize(elementData[key]);
                
                        if (!(key in elementData) || elementValue !== filterValue) {
                          return false;
                        }
                      }
                      return true;
                    });
                
                    if (allMatch) {
                      matchingElements.push(element);
                    }
                
                });

                // console.log(matchingElements)

                matchingElements.forEach(el => {
                    el.classList.remove('hidden')
                    el.setAttribute('aria-hidden', 'false')
                })
            }

            $('#ProductArtifiForm').attr('data-design-id', eventdata.data.custmizeProductId);
            $('#ProductArtifiForm').attr('data-product-sku', eventdata.data.sku);

            $('#ProductArtifiForm').find('.item-edit-btn').each(function() {
                $(this).attr('data-design-id', eventdata.data.custmizeProductId);
                $(this).attr('data-user-id', eventdata.data.userId);
                $(this).attr('data-product-sku', eventdata.data.sku);
            });


            $('#ProductArtifiForm').find('.variant-add-to-cart').each(function() {
                $(this).attr('data-design-id', eventdata.data.custmizeProductId);
                $(this).attr('data-user-id', eventdata.data.userId);
                $(this).attr('data-product-sku', eventdata.data.sku);
            });

            $('#ProductArtifiForm').find('.design-id').each(function() {
                $(this).text(eventdata.data.custmizeProductId);
            });

            $('#artifiIframeContainer').addClass('hidden');
            $('#ProductArtifiForm').removeClass('hidden');
            $('html, body').animate({
                scrollTop: $('#ProductArtifiForm').offset().top - 80
            }, 300);


            // var artifiPdfUrl =
            //     pdfApiPath + 
            //     '?customizedProductId=' + 
            //     eventdata.data.custmizeProductId+ 
            //     '&websiteId=' +
            //     website_id +
            //     '&webApiClientKey=' + 
            //     webapi_client_key +
            //     '&shop=' + 
            //     shop+
            //     '&env=' + 
            //     artifi_integration_url.replace('https://','').replace('http://','');

            // var artifiXmlUrl = 
            //     xmlApiPath + 
            //     '?customizedProductId=' + 
            //     eventdata.data.custmizeProductId + 
            //     '&websiteId=' +
            //     website_id +
            //     '&webApiClientKey=' + 
            //     webapi_client_key +
            //     '&shop=' + 
            //     shop+
            //     '&env=' + 
            //      artifi_integration_url.replace('https://','').replace('http://','');

            // baseUrl = baseUrl.replace("/pages/personalize", "");
            // var previewLinkUrl = baseUrl + '/admin/apps/' +
            //     artifi_app_api_key + '?designid=' +
            //     eventdata.data.custmizeProductId +
            //     '&productcode=' + eventdata.data.productCode;

            // var previewUrlProprtyName = '_Artifi Preview';
            // var pdfUrlProprtyName = '_Artifi Design PDF';
            // var xmlUrlProprtyName = '_Artifi Design XML';

            // // Get Artifi Sku's
            // var artifiVariantSku = getParameterByName('artifiVariantSku');
            // if (artifiVariantSku === "undefined") {
            //     artifiVariantSku = '';
            // }

            // var artifiProductSku = getParameterByName('artifiProductSku');
            // if (artifiProductSku === "undefined") {
            //     artifiProductSku = '';
            // }

            // //User Id
            // if (jQuery("#artifiUserId").val()) {
            //     var artifiUserId = jQuery("#artifiUserId").val();
            // } else {
            //     var artifiUserId = getParameterByName("userIdInQuote");
            // }

            // var propertiesObj = {
            //     _ArtifiDesignId: eventdata.data.custmizeProductId,
            //     _ArtifiPersonalizedImageThumb: thumbImagesArray[0],
            //     _ArtifiUserIdInQuote: artifiUserId,
            //     _ArtifiProduct: eventdata.data.productCode,
            //     _ArtifiVariant: eventdata.data.sku
            // };

            // propertiesObj[previewUrlProprtyName] = previewLinkUrl;

            // if (save_pdf_link === '1') {
            //     propertiesObj[pdfUrlProprtyName] = artifiPdfUrl;
            // }

            // if (save_xml_link === '1') {
            //     propertiesObj[xmlUrlProprtyName] = artifiXmlUrl;
            // }

            // // Save Text And Images Data
            // var customizedDataArray = getArtifiCustomizedData(eventdata.data.customizedData);

            // if (eventdata.data.productCode !== eventdata.data.sku && website_id !== 14) {
            //     var inputName = 'artifi_sku_' + eventdata.data.sku;
            //     var mapped_variant_id = jQuery("input[name = '" + inputName + "']").val();
            //     if (mapped_variant_id !== '' && mapped_variant_id !== null && typeof mapped_variant_id !== 'undefined') {
            //         varient_id = mapped_variant_id;
            //     }
            // }

            // jQuery.extend(propertiesObj, customizedDataArray);
            // var addPrd = function() {
            //     $.ajax({
            //         url: '/cart/add.js',
            //         type: 'POST',
            //         dataType: 'json', 
            //         data: {
            //             quantity: quantity,
            //             id: varient_id,
            //             properties: propertiesObj
            //         },
            //         success: function(cart) {
            //             $.ajax({
            //                 url: '/cart.js',
            //                 type: 'GET',
            //                 dataType: 'json',
            //                 success: function(responseObject) {
                                
            //                     var updatedUserId = jQuery('#artifiUserId').val();
            //                     if (updatedUserId === '') {
            //                         updatedUserId = responseObject.token;
            //                     }
                                
            //                     if ((artifiCustomSessionId.toString() !== updatedUserId.toString()) ||
            //                         (
            //                             artifiCustomSessionId.toString() === updatedUserId.toString() &&
            //                             guestinquote === "1"
            //                         )
            //                     ) {
            //                         if (
            //                             artifiCustomSessionId.toString() === updatedUserId.toString() &&
            //                             guestinquote === "1"
            //                         ) {
            //                             artifiCustomSessionId = responseObject.token;
            //                         }

            //                         jQuery(document).ready(function() {
            //                             Artifi.UpdateUserId({
            //                                 newUserId: updatedUserId,
            //                                 oldUserId: artifiCustomSessionId,
            //                                 IsGuest: artifiIsGuest,
            //                                 websiteId: website_id,
            //                                 webApiClientKey: webapi_client_key,
            //                                 successCallback: function() {
            //                                     window.location.href = '/cart';
            //                                 },
            //                                 errorCallback: function() {
            //                                     window.location.href = '/cart';
            //                                 }
            //                             });
            //                         });
            //                     } else {
            //                         window.location.href = '/cart';
            //                     }
            //                 },
            //                 error: function(xhr, status, error) {
            //                     //console.error("Error fetching cart details (/cart.js):", status, error);
            //                     //console.error("Raw response text:", xhr.responseText);
            //                 }
            //             });
            //         },
            //         error: function(xhr, status, error) {
            //             //console.error("Error adding product to cart (/cart/add.js):", status, error);
            //             //console.error("Raw response text:", xhr.responseText);
            //         }
            //     });
            // };

            this.cart = document.querySelector('cart-drawer');
            this.cartDrawer = document.querySelector('#CartDrawer');

            const self = this;
            
        
            var propertiesObj = {
                _ArtifiDesignId: eventdata.data.custmizeProductId,
                _ArtifiPersonalizedImageThumb: eventdata.data.savedDesigns[0],
                _ArtifiUserIdInQuote: eventdata.data.userId,
                _ArtifiProduct: eventdata.data.productCode,
                _ArtifiVariant: eventdata.data.sku,
                _ArtifiCustomSessionId: customSessionId
            };

        
            var addPrd = function() {
                $.ajax({
                    url: window.Shopify.routes.root + 'cart/add.js',
                    type: 'POST',
                    dataType: 'json', 
                    data: {
                        quantity: quantity,
                        id: variant_id,
                        properties: propertiesObj,
                        sections: this.cart.getSectionsToRender().map((section) => section.id)
                    },
                    success: function(cart) {
                        $.ajax({
                            url: window.Shopify.routes.root + 'cart.js',
                            type: 'GET',
                            dataType: 'json',
                            success: function(responseObject) {
                                // console.log(cart)
                                // console.log(responseObject)
                                var updatedUserId = jQuery('#artifiUserId').val();
                                if (updatedUserId === '') {
                                    updatedUserId = responseObject.token;
                                }
                                
                                if ((customSessionId.toString() !== updatedUserId.toString()) ||
                                    (
                                        customSessionId.toString() === updatedUserId.toString() &&
                                        guestinquote === "1"
                                    )
                                ) {
                                    if (
                                        customSessionId.toString() === updatedUserId.toString() &&
                                        guestinquote === "1"
                                    ) {
                                        customSessionId = responseObject.token;
                                    }

        
                                    jQuery(document).ready(function() {
                                        Artifi.UpdateUserId({
                                            newUserId: updatedUserId,
                                            oldUserId: customSessionId,
                                            IsGuest: artifiIsGuest,
                                            websiteId: website_id,
                                            webApiClientKey: webapi_client_key,
                                            successCallback: function() {
                                                // window.location.href = '/cart';
                                                console.log('success')
                                                self.cart.renderContents(cart);
                                                self.cartDrawer.open();
                                                document.querySelector('.proceed-to-cart').removeAttribute('aria-disabled');
                                            },
                                            errorCallback: function() {
                                                console.log('error')
                                                // window.location.href = '/cart';
                                                self.cart.renderContents(cart);
                                                self.cartDrawer.open();
                                                document.querySelector('.proceed-to-cart').removeAttribute('aria-disabled');
                                            }
                                        });
                                    });
                                } else {
                                    console.log('success')
                                    // window.location.href = '/cart';
                                    self.cart.renderContents(cart);
                                    self.cartDrawer.open();
                                    document.querySelector('.proceed-to-cart').removeAttribute('aria-disabled');
                                }
                            },
                            error: function(xhr, status, error) {
                                console.error("Error fetching cart details (/cart.js):", status, error);
                                console.error("Raw response text:", xhr.responseText);
                            }
                        });
                    },
                    error: function(xhr, status, error) {
                        console.error("Error adding product to cart (/cart/add.js):", status, error);
                        console.error("Raw response text:", xhr.responseText);
                    }
                });
            };

            if (typeof lineItemId !== 'undefined' && lineItemId != null) {
                $.ajax({
                    url: '/cart/change.js',
                    type: 'POST',
                    dataType: 'json', 
                    data: {
                        quantity: 0, 
                        line: lineItemId,
                        sections: self.cart.getSectionsToRender().map((section) => section.id)
                    },
                    success: function(data) {
                        addPrd(); // Proceed to add the new product
                    },
                    error: function(xhr, status, error) {
                        console.error("Error changing cart item (/cart/change.js):", status, error);
                        console.error("Raw response text (Check this for non-JSON content):", xhr.responseText);
                      
                        addPrd(); 
                    }
                });
            } 
            // else {
            //     // If no existing item, just add the new product
            //     addPrd();
            // }
        }
    }
}

if( integration_type != "headless" ) {
    if (window.addEventListener) {
        addEventListener("message", receiveMessage, false);
    } else {
        attachEvent("onmessage", receiveMessage);
    }
}

/*
 * Function to open Preview image popup
 */
function openArtifiPreviewPopup(productCode, userId, isGuest, designId, variantsCount, userIdInQuote, artifiProductSku, atifiVariantSku) {
    if (isGuest === '') {
        isGuest = 'true';
    }
    var issimple = 1;
    if (variantsCount > 1) {
        issimple = 0;
    }
    var childSku = '';
    if (issimple === 0) {
        childSku = productCode;
    }
    // Set Custom Product Codes if available
    if (artifiProductSku !== '') {
        productCode = artifiProductSku;
    }
    if (atifiVariantSku !== '') {
        childSku = atifiVariantSku;
    }
    if (issimple === 1) {
        childSku = '';
    }

    if (userId === '' || userIdInQuote == '') {
        jQuery.get('/cart.js').done(function(data) {
            var responseObject = JSON.parse(data);
            userId = responseObject.token;
            Artifi.PreviewPopUp({
                productCode: productCode,
                websiteId: website_id,
                userId: userId,
                isGuest: isGuest,
                width: 800,
                height: 600,
                designId: designId,
                sku: childSku,
                webApiclientKey: webapi_client_key,
                extraQueryString: '',
                cartQueryString: ''
            });
        });
    } else {
        Artifi.PreviewPopUp({
            productCode: productCode,
            websiteId: website_id,
            userId: userId,
            isGuest: isGuest,
            width: 800,
            height: 600,
            designId: designId,
            sku: childSku,
            webApiclientKey: webapi_client_key,
            extraQueryString: '',
            cartQueryString: ''
        });
    }
}

/*
 * Funtion to open Edit Design Page
 */
function artifiEditItem(event) {
    // console.log(event.target)
    var title = event.target.getAttribute('data-title');
    var productId = event.target.getAttribute('data-product-id');
    var variantId = event.target.getAttribute('data-variant-id');
    var designId = event.target.getAttribute('data-design-id');
    // var personalizeId = event.target.getAttribute('data-personalize-id');
    var variantsCount = event.target.getAttribute('data-variants-count');
    var productURL = event.target.getAttribute('data-url');
    var artifiSku = event.target.getAttribute('data-product-sku');
    var artifiProductSku = event.target.getAttribute('data-artifi-sku');
    var userIdInQuote = event.target.getAttribute('data-user-id');
    var lineItemId = event.target.getAttribute('data-line-item');
    var quantity = event.target.getAttribute('data-quantity');
    var customSessionId = event.target.getAttribute('data-custom-session-id');
    var issimple = 1;
    if (variantsCount > 1) {
        issimple = 0;
    }
    var guestinquote = '0';
    if (userIdInQuote === '') {
        guestinquote = '1';
    }

    // if (artifiVariantSku !== '' && artifiVariantSku !== 'undefined') {
    //     url += '&artifiVariantSku=' + artifiVariantSku;
    // }

    // if (reorder === 'reorder') {
    //     url += '&mode=reorder';
    // }

    if (title == 'Bass Drumhead'){
        let portTemplate = false;

        const url = `${artifi_integration_url}/Designer/Services/GetCustomizedProductById?customizedProductId=${designId}&websiteId=${website_id}&webApiClientKey=${webapi_client_key}`;

        fetch(url)
          .then(response => response.json())
          .then(data => {
            if (data.Data.CustomDesignModelList[0].TemplateCode.includes('Port')){
                portTemplate = true;
            }

            if (portTemplate && artifiSku.lastIndexOf('P') !== -1){
                artifiSku = artifiSku.slice(0, -1);
            }

            var url = productURL + '?id=' + variantId +
            '&design_id=' + designId +
            '&issimple=' + issimple +
            '&product=' + productId + 
            (lineItemId ? '&line_item_id=' + lineItemId : '') +
            (quantity ? '&quantity=' + quantity : '') +
            '&userIdInQuote=' + userIdInQuote +
            '&customSessionId=' + customSessionId +
            '&guestinquote=' + guestinquote +
            '&artifiSku=' + artifiSku;
    
            if (artifiProductSku !== '' && artifiProductSku !== 'undefined') {
                url += '&artifiProductSku=' + artifiProductSku;
            }

            window.location.href = url;
        })
          .catch(error => console.error("Error:", error));
    } else{

        var url = productURL + '?id=' + variantId +
        '&design_id=' + designId +
        '&issimple=' + issimple +
        '&product=' + productId + 
        (lineItemId ? '&line_item_id=' + lineItemId : '') +
        (quantity ? '&quantity=' + quantity : '') +
        '&userIdInQuote=' + userIdInQuote +
        '&customSessionId=' + customSessionId +
        '&guestinquote=' + guestinquote +
        '&artifiSku=' + artifiSku;

        if (artifiProductSku !== '' && artifiProductSku !== 'undefined') {
            url += '&artifiProductSku=' + artifiProductSku;
        }

        window.location.href = url;
    }
}

function artifiAddToCart(event) {
    var productId = event.target.getAttribute('data-product-id');
    var designId = event.target.getAttribute('data-design-id');
    var userId = event.target.getAttribute('data-user-id');
    var productSku = event.target.getAttribute('data-product-sku');
    var artifiSku = event.target.getAttribute('data-artifi-sku');
    var variantSku = event.target.getAttribute('data-variant-sku');
    var imageThumb = $('#ProductArtifiForm').find('.variant-image')[0].src;
    var variant_id = event.target.getAttribute('data-variant-id');
    var quantity = $('#VariantQty-' + variant_id).val();
    var lineItemId = null;
    var leadTime = event.target.getAttribute('data-lead-time');
    var guestinquote = '0';
    if (userId === '') {
        guestinquote = '1';
    }
    this.cart = document.querySelector('cart-drawer');
    this.cartDrawer = document.querySelector('#CartDrawer');
    
    const self = this;

    var propertiesObj = {
        _ArtifiDesignId: designId,
        _ArtifiPersonalizedImageThumb: imageThumb,
        _ArtifiUserIdInQuote: userId,
        _ArtifiProduct: artifiSku,
        _ArtifiVariant: productSku,
        _ArtifiCustomSessionId: artifiCustomSessionId,
        ...(leadTime != null && { "Lead Time": leadTime + ' business days' })
    };

    var addPrd = function() {
        $.ajax({
            url: window.Shopify.routes.root + 'cart/add.js',
            type: 'POST',
            dataType: 'json', 
            data: {
                quantity: quantity,
                id: variant_id,
                properties: propertiesObj,
                sections: self.cart.getSectionsToRender().map((section) => section.id)
            },
            success: function(cart) {
                $.ajax({
                    url: window.Shopify.routes.root + 'cart.js',
                    type: 'GET',
                    dataType: 'json',
                    success: function(responseObject) {
                        // console.log(cart)
                        // console.log(responseObject)
                        var updatedUserId = jQuery('#artifiUserId').val();
                        if (updatedUserId === '') {
                            updatedUserId = responseObject.token;
                        }
                        
                        if ((artifiCustomSessionId.toString() !== updatedUserId.toString()) ||
                            (
                                artifiCustomSessionId.toString() === updatedUserId.toString() &&
                                guestinquote === "1"
                            )
                        ) {
                            if (
                                artifiCustomSessionId.toString() === updatedUserId.toString() &&
                                guestinquote === "1"
                            ) {
                                artifiCustomSessionId = responseObject.token;
                            }

                            jQuery(document).ready(function() {
                                Artifi.UpdateUserId({
                                    newUserId: updatedUserId,
                                    oldUserId: artifiCustomSessionId,
                                    IsGuest: artifiIsGuest,
                                    websiteId: website_id,
                                    webApiClientKey: webapi_client_key,
                                    successCallback: function() {
                                        // window.location.href = '/cart';
                                        self.cart.renderContents(cart);
                                        self.cartDrawer.open();
                                        document.querySelector('.proceed-to-cart').removeAttribute('aria-disabled');
                                    },
                                    errorCallback: function() {
                                        // window.location.href = '/cart';
                                        self.cart.renderContents(cart);
                                        self.cartDrawer.open();
                                        document.querySelector('.proceed-to-cart').removeAttribute('aria-disabled');
                                    }
                                });
                            });
                        } else {
                            // window.location.href = '/cart';
                            self.cart.renderContents(cart);
                            self.cartDrawer.open();
                            document.querySelector('.proceed-to-cart').removeAttribute('aria-disabled');
                        }
                    },
                    error: function(xhr, status, error) {
                        console.error("Error fetching cart details (/cart.js):", status, error);
                        console.error("Raw response text:", xhr.responseText);
                    }
                });
            },
            error: function(xhr, status, error) {
                console.error("Error adding product to cart (/cart/add.js):", status, error);
                console.error("Raw response text:", xhr.responseText);
            }
        });
    };

    if (typeof lineItemId !== 'undefined' && lineItemId != null) {
        $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json', 
            data: {
                quantity: 0, 
                line: lineItemId,
                sections: this.cart.getSectionsToRender().map((section) => section.id)
            },
            success: function(data) {
                
                console.log("Old item successfully removed/updated.", data);
                addPrd(); // Proceed to add the new product
            },
            error: function(xhr, status, error) {
                console.error("Error changing cart item (/cart/change.js):", status, error);
                console.error("Raw response text (Check this for non-JSON content):", xhr.responseText);
                
                addPrd(); 
            }
        });
    } else {
        // If no existing item, just add the new product
        addPrd();
    }
}


function checkArtifiEnableAddToCart(event) {
    var variant_id = event.target.getAttribute('data-variant-id');
    if (event.target.value == 0){
        $('#ProductArtifiForm').find('#VariantAddToCart-' + variant_id).attr('aria-disabled', 'true');
    } else {
        $('#ProductArtifiForm').find('#VariantAddToCart-' + variant_id).attr('aria-disabled', 'false');
    }
}

/*
 * Generate GUID to store as checkout session identifier
 * before adding any item to the chart. It will not be required 
 * when atleast one item is added to the cart
 */
function getArtifiCustomSessionId() {
    var currentTimestamp = Math.floor(Date.now() / 1000);
    var randomNumber = getRandomArbitrary(1000, 100000);
    var guid = '';
    guid += currentTimestamp;
    guid += randomNumber;
    return guid;
}

/*
 * Function returns a random number between min (inclusive) and max (exclusive)
 */
function getRandomArbitrary(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}
/*
 * Get Customized Data as object
 */

function getArtifiCustomizedData(customizedDataObj) {

    var view_name = '';
    var edit_type = '';
    var key_name = '';
    var widget_key = '';
    var propertiesObj = {};
    var objectkey = '';
    var imageUrl = '';
    for (var key in customizedDataObj) {
        view_name = key;
        if ('text' in customizedDataObj[key]) {
            for (var key_1 in customizedDataObj[key].text) {
                edit_type = 'text';
                key_name = key_1;
                widget_key = customizedDataObj[key].text[key_1].widgetKey;

                objectkey = '_ Artifi Customizations : ' + view_name + ' ' + edit_type + ' ' + key_name;
                if (widget_key !== '') {
                    objectkey += ' ( ' + widget_key + ' )';
                }
                propertiesObj[objectkey] = customizedDataObj[key].text[key_1].text;
                widget_key = '';
            }
        }
        if ('image' in customizedDataObj[key]) {
            for (var key_2 in customizedDataObj[key].image) {
                edit_type = 'image';
                key_name = key_2;
                widget_key = customizedDataObj[key].image[key_2].widgetKey;
                objectkey = '_ Artifi Customizations : ' + view_name + ' ' + edit_type + ' ' + key_name;
                if (widget_key !== '') {
                    objectkey += ' ( ' + widget_key + ' )';
                }
                imageUrl = customizedDataObj[key].image[key_2].src;
                if (imageUrl.indexOf('http:') === -1 && imageUrl.indexOf('https:') === -1) {
                    imageUrl = 'https:' + imageUrl;
                }
                propertiesObj[objectkey] = imageUrl;
                widget_key = '';
            }
        }
    }
    return propertiesObj;
}

/*
 * Loads JQuery if not present
 * @param {type} url
 * @param {type} callback
 * @returns {undefined}
 */
function loadScript(url, callback) {

    var script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState) { //IE
        script.onreadystatechange = function() {
            if (script.readyState == "loaded" ||
                script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else { //Others
        script.onload = function() {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

var artifiAppJavaScript = function($) { 
    $(document).ready(
        function() { 
            var themeName = Shopify.theme.name ? Shopify.theme.name.toLowerCase() : "";
            if(integration_type == "headless"){ 
                
                if(personalizationType == "optional" || personalizationType == "required"){
                    
                    artifiCustomSessionId = jQuery('#artifiUserId').val();
                    artifiIsGuest = 'false';
                    if (!artifiCustomSessionId) {
                        artifiCustomSessionId = getArtifiCustomSessionId();
                        artifiIsGuest = 'true';
                    }
                    
                    var mode = getParameterByName("mode");
                    if(mode =="edit"){
                        artifiCustomSessionId = getParameterByName("customer_session_id");
                    }
                   
                    const artifiProductSku = jQuery("#artifiSku_0").val();

                    var design_id ="";
                    design_id = getParameterByName("design_id");

                    if(design_id){
                      var btnName ="Update Cart";
                    }else{
                      var btnName ="Add To Cart";
                    }

                    var childSku = artifiProductSku;
                    var idVal = jQuery('input[name="id"]').val();
                    var quantity = $('input[name="quantity"]').val();
                    var baseUrl = window.location.protocol + "//" + window.location.host;

                    //----------------------------------

                    if (themeName.includes("dawn")) { 

                        //Hide Original Button
                        $('.product-form__buttons').hide();

                        //Replace Original Image with Artifi Editor
                        $('.grid__item.product__media-wrapper').empty().append('<div id="artifi-editor"></div>');

                        //Add component in the form
                        var headlessContent =
                            '<div id="artifi-widget-div">'+
                                '<div id="artifi-product-attribute" data-attr-style="circle" data-show-display-name="true" style="margin-top:10px"></div>'+
                                '<div id="artifi-add-text" style="margin-top:10px"></div>'+
                                '<div id="artifi-text-widget-list" data-selector="artifi-text-widget-list" data-display-type="scroll"></div>'+
                                '<div id="artifi-clipart" class="my-2" data-image-id="image_1" data-view-code="" data-add-widget="" style="margin-top:10px"></div>'+
                                '<div id="artifi-upload-user-image" data-image-id="image_1" data-view-code="" data-add-widget="" style="margin-top:10px"></div>'+
                                '<div id="artifi-user-images" data-image-id="" data-view-code="" data-add-widget="" style="margin-top:10px"></div>'+
                                '<div><button type="button" id="reactAddToCart" style="margin-top:10px" class="product-form__submit button button--full-width button--primary">'+btnName+'</button></div>'+
                            '</div>';
                        
                        $('.product-form').before(headlessContent);
                        
                        //Initialize Artifi
                        Artifi.initialize({
                            webApiClientKey:webapi_client_key,
                            websiteId:website_id,
                            userId: artifiCustomSessionId,
                            isGuest: artifiIsGuest,
                            sku: artifiProductSku,
                            designId: design_id
                        });

                        if(mode =="edit"){
                            var editQty = getParameterByName("quantity");
                            if(editQty >0){
                                $('input[name="quantity"]').val(editQty);
                            }
                            $("#artifi_quantity").val(editQty);
                            $('.quantity__button[name="minus"]').removeClass('disabled');
                        }

                        //Quantity Validation
                        $('.quantity__input').on('keypress', function(event) {
                            if (event.key === 'Enter' || event.keyCode === 13) {
                                event.preventDefault();
                            }
                        });
        
                        function quantity_validation(){
                            var value = $('.quantity__input').val();
                            var errorDivId = $('#qty-error');
                            var errorMessage ="";
                            var isValid = /^[1-9]\d*$/.test(value);
                            if (!isValid) {
                              errorMessage = 'Invalid quantity.';
                            }
        
                            // Show error message if there's an error
                            if (errorMessage) {
                                $(".add-cart-btn").prop("disabled", true);
                                if (errorDivId.length === 0) {
                                    errorDivId = $('<div id="qty-error" style="color:red;font-size:14px"></div>');
                                    $(".quantity").after(errorDivId); 
                                }
                                errorDivId.text(errorMessage); 
                                $(this).focus();
                            } else {
                                $(".add-cart-btn").prop("disabled", false);
                                errorDivId.remove(); 
                            }
                        }
        
                        $('.quantity__input').on('keyup', function(event) {
                            quantity_validation();
                        });
                    
                        document.querySelector('.quantity__input').addEventListener('input', function (event) {
                              newQuantity = event.target.value; 
                              $("#artifi_quantity").val(newQuantity);
                        });

                        $('.quantity__button[name="plus"]').on('click', function () {
                            const quantity = $("#artifi_quantity").val();
                            var errorDivId = $('#qty-error');
                            if ($.isNumeric(quantity)) {   
                                if(quantity <= "0"){
                                    errorDivId.remove(); 
                                    $(".add-cart-btn").prop("disabled", false);
                                }              
                                var qtyVal = parseInt($("#artifi_quantity").val())+1; 
                                $("#artifi_quantity").val(qtyVal);
                            } else { 
                                $("#artifi_quantity").val(1);
                                errorDivId.remove(); 
                                $(".add-cart-btn").prop("disabled", false);
                            }
                        });

                        $('.quantity__button[name="minus"]').on('click', function () {
                            const quantity = $("#artifi_quantity").val();
                            var errorDivId = $('#qty-error');
                            if ($.isNumeric(quantity)) {
                                var qtyVal = parseInt($("#artifi_quantity").val())-1; 
                                $("#artifi_quantity").val(qtyVal);
                            } else {
                                $("#artifi_quantity").val(1);
                                errorDivId.remove(); 
                                $(".add-cart-btn").prop("disabled", false);
                            }
                        });

                    } else {
                        function waitForElement(selector, callback) {
                            const element = document.querySelector(selector);
                            if (element) {
                                callback(element);
                            } else {
                                setTimeout(() => waitForElement(selector, callback), 100);
                            }
                        }

                        // Wait for media-gallery and replace it with editor
                        waitForElement("media-gallery", function(mediaGallery) {
                            // Insert new div after the media gallery
                            mediaGallery.insertAdjacentHTML("afterend", '<div id="artifi-editor"></div>');

                            // Remove the original media-gallery
                            mediaGallery.remove();
                        });

                        function insertArtifiWidget(callback) {
                            const $qs = $("quantity-selector-component");

                            if ($qs.length && $("#artifi-widget-div").length === 0) {
                                var widgetHTML = `
                                    <div id="artifi-widget-div">
                                        <div id="artifi-product-attribute" data-attr-style="circle" data-show-display-name="true" style="margin-top:10px"></div>
                                        <div id="artifi-add-text" style="margin-top:10px"></div>
                                        <div id="artifi-text-widget-list" data-selector="artifi-text-widget-list" data-display-type="scroll"></div>
                                        <div id="artifi-clipart" class="my-2" data-image-id="image_1" data-view-code="" data-add-widget="" style="margin-top:10px"></div>
                                        <div id="artifi-upload-user-image" data-image-id="image_1" data-view-code="" data-add-widget="" style="margin-top:10px"></div>
                                        <div id="artifi-user-images" data-image-id="" data-view-code="" data-add-widget="" style="margin-top:10px"></div>
                                        <div>
                                            <button type="button" id="reactAddToCart" style="margin-top:10px" class="product-form__submit button button--full-width button--primary">${btnName}</button>
                                        </div>
                                    </div>
                                `;
                                $qs.after(widgetHTML);

                                // run callback (initialize) after insertion
                                if (typeof callback === "function") {
                                    callback();
                                }
                            }
                        }

                        // Wait until quantity-selector-component exists, then insert widget and init Artifi
                        function waitForQuantitySelector() {
                            const el = document.querySelector("quantity-selector-component");
                            if (el) {
                                insertArtifiWidget(function() {
                                    //Hide original add to cart
                                    $("add-to-cart-component").closest("span").hide();
                                    $(".product-form-text__error").hide();

                                    //Initialize Artifi
                                    Artifi.initialize({
                                        webApiClientKey: webapi_client_key,
                                        websiteId: website_id,
                                        userId: artifiCustomSessionId,
                                        isGuest: artifiIsGuest,
                                        sku: artifiProductSku,
                                        designId: design_id
                                    });
                                });
                            } else {
                                setTimeout(waitForQuantitySelector, 100);
                            }
                        }

                        waitForQuantitySelector();


                        if(mode =="edit"){
                            var editQty = getParameterByName("quantity");
                            if(editQty >0){
                                $('input[name="quantity"]').val(editQty);
                            }
                            $("#artifi_quantity").val(editQty);
                            //$('.quantity__button[name="minus"]').removeClass('disabled');
                        }

                        //Quantity Validation
                        //$('.quantity__input').on('keypress', function(event) {
                        $(document).on('keypress', 'quantity-selector-component input[name="quantity"]', function(e) {
                            if (event.key === 'Enter' || event.keyCode === 13) {
                                event.preventDefault();
                            }
                        });
        
                        function quantity_validation(){
                            var value = $('.quantity__input').val();
                            var errorDivId = $('#qty-error');
                            var errorMessage ="";
                            var isValid = /^[1-9]\d*$/.test(value);
                            if (!isValid) {
                              errorMessage = 'Invalid quantity.';
                            }
        
                            //Show error message if there's an error
                            if (errorMessage) {
                                $(".add-cart-btn").prop("disabled", true);
                                if (errorDivId.length === 0) {
                                    errorDivId = $('<div id="qty-error" style="color:red;font-size:14px"></div>');
                                    $(".quantity").after(errorDivId); 
                                }
                                errorDivId.text(errorMessage); 
                                $(this).focus();
                            } else {
                                $(".add-cart-btn").prop("disabled", false);
                                errorDivId.remove(); 
                            }
                        }
        
                        //$('.quantity__input').on('keyup', function(event) {
                        $(document).on('keyup', 'quantity-selector-component input[name="quantity"]', function(e) {
                            quantity_validation();
                        });

                        $(document).on('input', 'quantity-selector-component input[name="quantity"]', function() {
                            var $input = $(this);
                            var qty = parseInt($input.val()) || 1;
                            if (qty < 1) {
                                $input.val(1);
                            }
                            $('#artifi_quantity').val(qty);
                        });
                    
                      

                        $(document).on('click', 'button.quantity-plus', function (event) {
                            // In case the click is on span/svg inside the button
                            var $btn = $(event.target).closest('button.quantity-plus');
                            
                            if ($btn.length) {
                                const quantity = $("#artifi_quantity").val();
                                var errorDivId = $('#qty-error');
                                if ($.isNumeric(quantity)) {   
                                    if(quantity <= "0"){
                                        errorDivId.remove(); 
                                        $(".add-cart-btn").prop("disabled", false);
                                    }              
                                    var qtyVal = parseInt($("#artifi_quantity").val())+1; 
                                    $("#artifi_quantity").val(qtyVal);
                                } else { 
                                    $("#artifi_quantity").val(1);
                                    errorDivId.remove(); 
                                    $(".add-cart-btn").prop("disabled", false);
                                }
                            }
                        });

                        $(document).on('click', 'button.quantity-minus', function (event) {
                            var $btn = $(event.target).closest('button.quantity-minus');
                            
                            if ($btn.length) {
                                const quantity = $("#artifi_quantity").val(); 
                                var errorDivId = $('#qty-error');
                                if ($.isNumeric(quantity)) { 
                                    var qtyVal = parseInt($("#artifi_quantity").val())-1; 
                                    if(parseInt($("#artifi_quantity").val()) == 1){
                                        $("#artifi_quantity").val(1);
                                    }else{
                                        $("#artifi_quantity").val(qtyVal);
                                    }
                                } else {
                                    $("#artifi_quantity").val(1);
                                    errorDivId.remove(); 
                                    $(".add-cart-btn").prop("disabled", false);
                                }
                            }
                        });
                    }
                    
                    //----------------------------------------------------------
                    
                    $(document).on("click", "#reactAddToCart", function () {
                        Artifi.addToCart();
                    });

                    window.addEventListener("artifi-add-to-cart-success", function (e) {
                       
                        var cartJson  = JSON.parse(e.detail.data);
                        console.log("Artifi Cart Success");

                        var designId = cartJson.designId;
                        var thumbanailUrl = cartJson.previewThumbnailImages;
                        var productSku = cartJson.sku;

                        var artifiPdfUrl =
                            pdfApiPath + 
                            '?customizedProductId=' + 
                            designId+ 
                            '&websiteId=' +
                            website_id +
                            '&webApiClientKey=' + 
                            webapi_client_key +
                            '&shop=' + 
                            shop+
                            '&env=' + 
                            artifi_integration_url.replace('https://','').replace('http://','');

                        var artifiXmlUrl = 
                            xmlApiPath + 
                            '?customizedProductId=' + 
                            designId + 
                            '&websiteId=' +
                            website_id +
                            '&webApiClientKey=' + 
                            webapi_client_key +
                            '&shop=' + 
                            shop+
                            '&env=' + 
                            artifi_integration_url.replace('https://','').replace('http://','');

                        baseUrl = baseUrl.replace("/pages/personalize", "");
                        var previewLinkUrl = baseUrl + '/admin/apps/' +
                                artifi_app_api_key + '?designid=' +
                                designId +
                                '&productcode=' + artifiProductSku;
                    
                        var previewUrlProprtyName = '_Artifi Preview';
                        var pdfUrlProprtyName = '_Artifi Design PDF';
                        var xmlUrlProprtyName = '_Artifi Design XML';
                        
                        var propertiesObj = { 
                            _ArtifiDesignId : designId,
                            _ArtifiPersonalizedImageThumb : thumbanailUrl,
                            _ArtifiUserIdInQuote : artifiCustomSessionId,
                            _ArtifiProduct : artifiProductSku,
                            _ArtifiVariant : productSku,
                            _ArtifiIntegrationType : 'headless'
                        };

                        propertiesObj[previewUrlProprtyName] = previewLinkUrl;
          
                        if (save_pdf_link === '1') {
                            propertiesObj[pdfUrlProprtyName] = artifiPdfUrl;
                        }
            
                        if (save_xml_link === '1') {
                            propertiesObj[xmlUrlProprtyName] = artifiXmlUrl;
                        }
                        var lineItemId = getParameterByName("line_item_id");
                        
                        var addToCart = function () {
                            // First AJAX call: Add to cart
                            $.ajax({
                                url: window.Shopify.routes.root + "cart/add.js",
                                data: {
                                    quantity: parseInt($("#artifi_quantity").val()),
                                    id: idVal,
                                    properties: propertiesObj,
                                },
                                type: "post",
                                dataType: "json", 
                                success: function (item) {
                                    $.ajax({
                                        url: window.Shopify.routes.root + "cart.js",
                                        type: "get",
                                        dataType: "json", 
                                        success: function (cart) {
                                            //console.log("Cart successfully updated:", cart);
                                            window.location.href = "/cart";
                                        },
                                        error: function (xhr, status, error) {
                                            console.error("Error fetching cart:", status, error);
                                            console.error("Cart Response Text:", xhr.responseText);
                                        }
                                    });
                                },
                                error: function (xhr, status, error) {
                                    console.error("Error adding to cart:", status, error);
                                    try {
                                        var response = JSON.parse(xhr.responseText);
                                        if (response.description) {
                                            //console.error("Shopify Error Description:", response.description);
                                        }
                                    } catch (e) {
                                        //console.error("Raw Response Causing Syntax Error:", xhr.responseText);
                                    }
                                }
                            });
                        }

                        if (typeof lineItemId !== "undefined" && lineItemId != null) {
                            $.ajax({
                                url: "/cart/change.js",
                                data: {
                                    quantity: 0,
                                    line: lineItemId,
                                },
                                type: "post", 
                                dataType: "json", 
                                success: function (cart) {
                                    //console.log("Item successfully removed. Updated cart:", cart);
                                    addToCart(); 
                                },
                                error: function (xhr, status, error) {
                                    console.error("Error changing cart item:", status, error);
                                    console.error("Raw Response Text:", xhr.responseText);

                                    try {
                                        var response = JSON.parse(xhr.responseText);
                                        if (response.description) {
                                            console.log("Cart Error: " + response.description);
                                        }
                                    } catch (e) {
                                        console.log("An unexpected error occurred while updating the cart.");
                                    }
                                }
                            });
                        }else{
                            addToCart();
                        }
                    });
          
                    window.addEventListener("artifi-add-to-cart-error", function (e) {
                        console.log("Add to cart is failed");
                    });
                }
            }else{

                //This code is for Iframe
                var hideAddToCart = 0;

                /*
                * Set Cart Button Text
                */
                if ($(artifiButtonAddToCart).length) {
                    $(artifiSpanAddToCartText).text(text_cart_button);
                }

                /*
                * Open the Personalization Iframe
                */

                // console.log('iframeContainer')
                // console.log($('#artifiIframeContainer').length)
                if ($('#artifiIframeContainer').length) {
                    setInterval(function() {
                        if (typeof openPersonalizeIframe === "function") {
                            openPersonalizeIframe();
                        }
                    }, 1000);
                }

                /*
                * Check if artifi product - and add personalize button
                */
                // console.log('check if artifi product')
                // console.log($('#isArtifiProduct'))
                // console.log($('#isArtifiProduct').val())
                // console.log($('#isArtifiProduct').length)
                // console.log($(artifiButtonAddToCart).length)
                // console.log(typeof artifi_app_api_key)
                if ($(artifiButtonAddToCart).length && $('#isArtifiProduct').length && $('#isArtifiProduct').val()) {
                    var myInterval = setInterval(
                        function() {
                            if (typeof artifi_app_api_key === "undefined") {
                                // do nothing
                            } else {
                                var issimple = '1';
                                
                                if ($('#ProductSelect option').length > 1) {
                                    issimple = '0';
                                }
                                jQuery(artifiButtonAddToCart).after('<input type="hidden" name="artifiSku" id="artifiSku" value="' + meta.product.variants[0].sku + '"' +
                                    '/><input type="hidden" name="issimple" id="issimple" value="' + issimple + '">');
                                if ($('#isPersonalizationOptional').val() === '0') {
                                    hideAddToCart = 1;
                                    $(artifiButtonAddToCart).hide();
                                }

                                /*
                                * Personalize button click event
                                * Function to open new added personalization page by App installer
                                */
                                jQuery(document).on('click', '#artifiPersonalize', function(e) {
                                    console.log('artifiPersonalize click')
                                    e.preventDefault();
                                    var selectedSku = jQuery('#ProductSelect option:selected').attr('value');
                                    
                                    var idVal = $("#ProductSelect").val(); 
                                    if (typeof idVal === 'undefined' || idVal === null) {
                                        //idVal = jQuery('input[name="product_id"]').val();
                                        idVal = jQuery('select[name="id"]').val();
                                    }
                                    var artifiSkuVal = jQuery('#artifiSku').val();
                                    var product_id = $('input[name="product_id"]').val();
                                    var isSimpleVal = jQuery('#issimple').val();
                                    var selectedQty = $('input[name="quantity"]').val();
                                    
                                    var userIdInQuote = getArtifiCustomSessionId();
                                    var personalize_url = '/pages/Personalize?id=' + idVal + 
                                      '&artifiSku=' + artifiSkuVal + 
                                      '&quantity=' + selectedQty + 
                                      '&issimple=' + isSimpleVal + 
                                      '&product=' + product_id +
                                      '&userIdInQuote=' + userIdInQuote;

                                    // Get Prod Artifi Sku
                                    var artifiProductSku = jQuery('#artifiSku_0').val();
                                    if (artifiProductSku !== '') {
                                        personalize_url += '&artifiProductSku=' + artifiProductSku;
                                    }
                                    // Get Variant Artifi Sku
                                    var artifiVariantSku = jQuery('#artifiSku_' + selectedSku).val();
                                    if (artifiVariantSku !== '') {
                                         var variant_val = jQuery('input[name="product_id"]').val();
                                         var variant_sku_val = jQuery('#artifiSku_' + variant_val).val();
                                         personalize_url += '&artifiVariantSku=' + variant_sku_val;
                                    }
                                    window.location.href = personalize_url;
                                });
                                clearInterval(myInterval);
                            }
                        }, 1000
                    );
                }
                if (hideAddToCart === 0) {
                    jQuery(artifiButtonAddToCart).show();
                }

                jQuery(document).on('click', '.artifi-plp-personalize', function(e) {
                    e.preventDefault();

                    var $el = $(this);

                    var productId = $el.data('product-id');
                    var productSku = $el.data('product-sku');
                    var artifiSku = $el.data('artifi-sku');
                    var variantId = $el.data('variant-id');
                    var issimple = $el.data('issimple');
                    var productURL = $el.data('url');
                    var quantity  = 1;
                    var userIdInQuote = getArtifiCustomSessionId();

                    
                    var personalize_url = productURL + '?id=' + variantId + 
                        '&artifiSku=' + productSku + 
                        '&quantity=' + quantity + 
                        '&issimple=' + issimple + 
                        '&product=' + productId +
                        '&userIdInQuote=' + userIdInQuote;

                    // Get Prod Artifi Sku
                    personalize_url += '&artifiProductSku=' + artifiSku;
                   
                    // Get Variant Artifi Sku
                    var variant_sku_val = '';
                    personalize_url += '&artifiVariantSku=' + variant_sku_val;

                    window.location.href = personalize_url;
                });
                
            }
        }
    );
};

if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', function() {
        jQuery311 = jQuery.noConflict(true);
        artifiAppJavaScript(jQuery311);
    });
} else {
    artifiAppJavaScript(jQuery);
}


function reorderHeadless(productCode, userId ,designId, quantity){ 

    var url= reorder_url+'/Design/GetReorder?designId='+designId+'&userId='+userId+'&websiteId='+website_id+'&webApiClientKey='+webapi_client_key;
    
    jQuery.ajax({
        url: url,
        method: 'GET', 
        success: function(result) {
            if (result !== '') {
                var res = JSON.parse(result);
                
                if(res.Response === "Success"){
                    var designId = res.Data.DesignId;
                    var cartJson = res.Data.CartJson;

                    //var reorder_sku = cartJson.productDetails.sku;
                    //var reorder_thumbnail = cartJson.designDetails.views[0].previewThumbnailUrl;

                    var reorder_sku = res.Data.CartJson.sku;
                    var reorder_thumbnail = res.Data.CartJson.previewThumbnailImages[0];
                    
                    var artifiPdfUrl =
                        pdfApiPath + 
                        '?customizedProductId=' + 
                        designId+ 
                        '&websiteId=' +
                        website_id +
                        '&webApiClientKey=' + 
                        webapi_client_key +
                        '&shop=' + 
                        shop+
                        '&env=' + 
                        artifi_integration_url.replace('https://','').replace('http://','');

                    var artifiXmlUrl = 
                        xmlApiPath + 
                        '?customizedProductId=' + 
                        designId + 
                        '&websiteId=' +
                        website_id +
                        '&webApiClientKey=' + 
                        webapi_client_key +
                        '&shop=' + 
                        shop+
                        '&env=' + 
                        artifi_integration_url.replace('https://','').replace('http://','');

                    var baseUrl = window.location.protocol + "//" + window.location.host;
                    baseUrl = baseUrl.replace("/pages/personalize", "");
                    var previewLinkUrl = baseUrl + '/admin/apps/' +
                        artifi_app_api_key + '?designid=' +designId +
                        '&productcode=' + productCode;
                  
                    var previewUrlProprtyName = '_Artifi Preview';
                    var pdfUrlProprtyName = '_Artifi Design PDF';
                    var xmlUrlProprtyName = '_Artifi Design XML';
          
                    var propertiesObj = {
                      _ArtifiDesignId : designId,
                      _ArtifiPersonalizedImageThumb : reorder_thumbnail,
                      _ArtifiUserIdInQuote : userId,
                      _ArtifiProduct : productCode,
                      _ArtifiVariant : reorder_sku,
                      _ArtifiIntegrationType : 'headless'
                    };

                    propertiesObj[previewUrlProprtyName] = previewLinkUrl;
        
                    if (save_pdf_link === '1') {
                        propertiesObj[pdfUrlProprtyName] = artifiPdfUrl;
                    }
          
                    if (save_xml_link === '1') {
                        propertiesObj[xmlUrlProprtyName] = artifiXmlUrl;
                    }

                    var addToCart = function () {
                        $.ajax({
                            url: window.Shopify.routes.root + "cart/add.js",
                            data: {
                                quantity : quantity,
                                id : productCode,
                                properties : propertiesObj,
                            },
                            type: "post",
                            dataType: "json", 
                            success: function (item) {
                                $.ajax({
                                    url: window.Shopify.routes.root + "cart.js",
                                    type: "get",
                                    dataType: "json", 
                                    success: function (cart) {
                                        //console.log("Cart successfully updated:", cart);
                                        window.location.href = "/cart";
                                    },
                                    error: function (xhr, status, error) {
                                        console.error("Error fetching cart:", status, error);
                                        console.error("Cart Response Text:", xhr.responseText);
                                    }
                                });
                            },
                            error: function (xhr, status, error) {
                                console.error("Error adding to cart:", status, error);
                                try {
                                    var response = JSON.parse(xhr.responseText);
                                    if (response.description) {
                                        //console.error("Shopify Error Description:", response.description);
                                    }
                                } catch (e) {
                                    //console.error("Raw Response Causing Syntax Error:", xhr.responseText);
                                }
                            }
                        });
                    }
                    //Call method Add to Cart
                    addToCart();
                }
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error("AJAX request failed: ", textStatus, errorThrown);
        }
    });
}